const mutations = {
  setPeople(state, value) {
    state.people = value || [];
  },
  setClusters(state, value) {
    state.clusters = value || [];
  },
  setPageItems(state, value) {
    state.pageItems = value || [];
  },
  setTotalRowCount(state, value) {
    state.totalRowCount = value || 0;
  },
  setLoading(state, value) {
    state.loading = value;
  }
};

export default mutations;
